module.exports = __webpack_public_path__ + "img/main01.59ea266a.jpg";